import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import CategoryProductListLoading from '~/components/organisms/Category/Loading/CategoryProductListLoading.vue';
export default {
  name: 'CategoryLoading',
  components: {
    CategoryProductListLoading: CategoryProductListLoading
  },
  props: {
    search: {
      type: Boolean,
      default: false
    }
  }
};